// Definição para o modal de busca de Usuários
// Factory function - recebe adminInterno e idEmpresa como parâmetros
// displayField usa nomeResolvido (fallback: NomeExibicao → Nome)
// Filtro fixo: apenas usuários ativos (statusUsuario = "Ativo")

export const criarConfigBuscaUsuario = (adminInterno = false, idEmpresa = null) => {
  const filtros = { statusUsuario: 'Ativo' }

  // Quando idEmpresa é fornecido, filtra pelos usuários da empresa
  // (independente de adminInterno, pois o admin pode selecionar empresa)
  if (idEmpresa) {
    filtros.idEmpresa = idEmpresa
  } else if (adminInterno) {
    // Sem empresa definida, mostra apenas usuários internos da Camuri Tech
    filtros.adminInterno = true
  }

  let titulo = 'Selecionar Usuário'
  if (idEmpresa) {
    titulo = 'Selecionar Usuário da Empresa'
  } else if (adminInterno) {
    titulo = 'Selecionar Usuário Interno'
  }

  return {
    label: 'Usuário',
    placeholder: 'Nome ou E-mail...',
    titulo,
    endpointApi: 'Usuarios',
    idField: 'idUsuario',
    displayField: 'nomeResolvido',
    descField: 'email',

    camposFiltro: [
      { label: 'Nome', model: 'nome', tipo: 'text' },
      { label: 'E-mail', model: 'email', tipo: 'text' }
    ],

    colunasGrid: [
      { header: 'Nome', dataField: 'nomeResolvido', width: '40%' },
      { header: 'E-mail', dataField: 'email', width: '40%' },
      { header: 'Status', dataField: 'statusUsuario', width: '20%' }
    ],

    filtrosFixos: filtros
  }
}
